import Comunicados from "../alumno/Comunicados";
export default function PadreComunicados() {
    return <Comunicados />;
}
